import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { Guideline, RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';

const MedicalCriteria2 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { onBrowsingCriteriaChange, getBrowsingCriteriaValue },
  } = useRootStore();

  const bcName = 'metallicLevel_FILTER';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'Platinum',
      label: 'I want the most coverage possible (highest cost)',
      value: 'Platinum',
    },
    {
      id: 'Gold',
      label: 'I want more coverage than average (higher cost)',
      value: 'Gold',
    },
    {
      id: 'Silver',
      label: 'I am looking for a good balance of monthly costs and coverage (average cost)',
      value: 'Silver',
    },
    {
      id: 'Expanded bronze',
      label: 'I’m looking for the lowest monthly cost (lowest cost)',
      value: 'Expanded bronze',
    },
  ];

  return (
    <div>
      <TextBlock title="Budget" subtitle="What is your health insurance budget?" />
      <RadioGroup
        label=""
        value={getBrowsingCriteriaValue(bcName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBrowsingCriteriaChange(bcName, e.target.value);
        }}
      />
      <Guideline
        simpleStyles
        labels={{
          opened: 'Learn more about metal levels and the relationship between monthly cost and deductible',
          closed: 'Learn more about metal levels and the relationship between monthly cost and deductible',
        }}
        className={classes.guidelineWrapper}
        content={
          <>
            <ul className={classes.guidelineList}>
              <li className={classes.guidelineItem}>
                Small group plans are categorized by the following metal levels: Platinum, Gold, Silver, and Bronze
              </li>
              <li className={classes.guidelineItem}>
                Higher metal levels (Platinum/Gold) usually have lower deductibles and out-of-pocket costs, making them
                more predictable for employees
              </li>
              <li className={classes.guidelineItem}>
                Lower metal levels (Silver/Bronze) come with higher deductibles and cost-sharing, shifting more upfront
                cost to the member
              </li>
              <li className={classes.guidelineItem}>
                Monthly premiums decrease as you move from Platinum to Bronze, but employees may face higher costs when
                they actually use care
              </li>
            </ul>
          </>
        }
      />
    </div>
  );
});

export default withCriteria(MedicalCriteria2, 2);
